<h1 mat-dialog-title>修改昵称</h1>

<div mat-dialog-content class="content">
  <mat-form-field appearance="outline">
    <mat-label>手机号</mat-label>
    <input matInput placeholder="请输入手机号" [(ngModel)]="phone" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>验证码</mat-label>
    <input matInput placeholder="请输入验证码" [(ngModel)]="code" />

    <button
      mat-raised-button
      matSuffix
      style="margin-right: 10px; color: white"
      color="primary"
      (click)="sendCode($event)"
      [disabled]="!phone || timeout > 0"
    >
      发送<ng-container *ngIf="timeout > 0">({{ timeout }})</ng-container>
    </button>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>取消</button>
  <button
    class="confirm"
    mat-flat-button
    color="primary"
    (click)="onOk()"
    [disabled]="loading"
  >
    确认
  </button>
</div>
